"use client";

import React from "react";
import { Instagram, Linkedin, Twitter, MapPin, Mail, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4">
        <div className="h-4 w-24 bg-white/10 animate-pulse rounded-md" />
        <div className="h-4 w-24 bg-white/10 animate-pulse rounded-md" />
        <div className="h-4 w-24 bg-white/10 animate-pulse rounded-md" />
      </div>;
  }

  // ADDED: Transform the menu items to catch "Ոլորտներ"
  const transformedMenuItems = menuItems.map(item => {
    if (item.label === "Ոլորտներ") {
      return {
        ...item,
        href: "/#ոլորտներ"
      };
    }
    return item;
  });
  return <NavigationMenu viewport={false} className="justify-start">
      <NavigationMenuList className="flex-col items-start justify-start gap-4">
        {/* CHANGED: map over transformedMenuItems instead of menuItems */}
        {transformedMenuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild className="bg-transparent hover:bg-transparent focus:bg-transparent data-[active=true]:bg-transparent data-[state=open]:bg-transparent hover:text-primary focus:text-primary text-white uppercase font-default text-xs px-0 py-0 h-auto transition-colors tracking-widest">
              <Link to={item.href || "#"}>{item.label}</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="252323" id="footer" className="text-white py-[clamp(40px,8vw,64px)] px-[clamp(16px,4vw,24px)] border-t border-white/10 !bg-[rgba(21,16,40,1)] light">
      <div className="max-w-7xl mx-auto">
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-[clamp(32px,6vw,64px)] py-12 relative">
          {}
          <div className="hidden md:block absolute left-1/2 top-1/2 -translate-y-1/2 w-px h-48 bg-white/10" />

          {}
          <div className="flex flex-col gap-8">
            <Link to="/" className="inline-block transition-opacity hover:opacity-80">
              {}
               <WvcLogo className="w-auto text-primary h-[clamp(50px,12vw,100px)] !max-h-none [&_svg]:w-auto [&_svg]:text-primary [&_svg]:h-[clamp(50px,12vw,100px)]" />
            </Link>

            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-3 text-white">
                <MapPin className="size-5 text-white" />
                <span className="text-sm font-default">&nbsp;Երևան, Հակոբ Հակոբյան, 3</span>
              </div>
              <div className="flex items-center gap-3 text-white">
                <Mail className="size-5 text-white" />
                <Link to="mailto:info@geocosmos.am" className="text-sm font-default hover:text-primary transition-colors">info@geocosmos.am</Link>
              </div>
              <div className="flex items-center gap-3 text-white">
                <Phone className="size-5 text-white" />
                <Link to="tel:+37410510000" className="text-sm font-default hover:text-primary transition-colors">+374 12 588 222</Link>
              </div>
              <div className="mt-2">
                <Link to="#" className="text-white hover:text-primary transition-all p-2 rounded-md border border-white/20 hover:border-primary/50 bg-white/5 inline-flex items-center justify-center" aria-label="LinkedIn">
                  <Linkedin className="size-5" />
                </Link>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-white uppercase font-default text-sm tracking-widest font-bold">Գլխավոր</h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>
        </div>

        {}
        

      </div>
    </section>;
}